import { get, post } from './http-calls';

export let getTCardJobTypesByID = async (id) => {
    let data = await get(`TCardStatus/TCardStatusGetDetails?TCardStatusID=${id}`, { useAuthToken: true });
    return data;
};

export const postTCardJobTypes = async (data) => {
    let res = await post(`TCardStatus/TCardStatusAddUpdate`, data, { useAuthToken: true });
    return res;
};
